var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageSize main"},[_c('div',{staticClass:"footerNum"},[_vm._v("2 of 6")])])
}]

export { render, staticRenderFns }